module.exports = __webpack_public_path__ + "img/save-survey-ted.2cb2dcef.svg";